// src/pages/About/About.jsx
import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <div className="container">
        <div className="page-header">
          <h1>À propos de nous</h1>
          <p>Notre mission est de rendre vos rêves de voyage réalité</p>
        </div>

        <div className="about-content">
          <div className="about-text">
            <h2>Notre Histoire</h2>
            <p>
              Fondée en 2010, TravelExplorer est née de la passion pour les voyages 
              et la découverte de nouvelles cultures. Notre équipe de voyageurs 
              expérimentés sélectionne soigneusement chaque destination pour vous 
              offrir des expériences authentiques et mémorables.
            </p>
            
            <h3>Notre Mission</h3>
            <p>
              Rendre le voyage accessible à tous tout en garantissant des expériences 
              de qualité. Nous croyons que chaque voyage transforme et enrichit notre 
              vision du monde.
            </p>

            <div className="stats-grid">
              <div className="stat-item">
                <div className="stat-number">50,000+</div>
                <div className="stat-label">Voyageurs satisfaits</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">100+</div>
                <div className="stat-label">Destinations</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">15+</div>
                <div className="stat-label">Pays visités</div>
              </div>
            </div>
          </div>
          
          <div className="about-image">
            <img 
              src="https://images.unsplash.com/photo-1521737711867-e3b97375f902" 
              alt="Équipe TravelExplorer" 
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;